import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=02c49a62&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/22413/203/Snaply5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02c49a62')) {
      api.createRecord('02c49a62', component.options)
    } else {
      api.reload('02c49a62', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=02c49a62&", function () {
      api.rerender('02c49a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/snaply/CategoryItem.vue"
export default component.exports